/**
 * promptForge · «Собери промпт для AI с превью последствий» (S15 · T06).
 * Per ADR-014. Чипы-ограничения сужают задачу — превью «вывода AI» (.pf-preview)
 * меняется от God-object к чистому LoginPage по числу активных ограничений (готовые
 * состояния в <template data-level>). Чип data-noop ничего не сужает (учит отличать
 * полезное ограничение от пустого). Достигнут полный набор → чистый вывод.
 *
 * Контракт разметки:
 *   <div class="pforge" data-fin="мораль">
 *     <div class="pf-prompt"><span class="pf-base">отрефактори мой код</span><span class="pf-adds"></span></div>
 *     <div class="pf-chips">
 *       <button type="button" class="pf-chip" data-add="onepage">только страница логина</button> …
 *       <button type="button" class="pf-chip" data-noop>будь повежливее</button></div>
 *     <div class="pf-plabel">что выдаст AI:</div>
 *     <pre class="pf-preview"><code>БАЗОВЫЙ вывод = God-object</code></pre>
 *     <div class="pf-verdict" aria-live="polite"></div>
 *     <template class="pf-out" data-level="1">…</template>  (по числу активных ограничений)
 *   </div>
 *
 * No-JS: виден базовый вывод + список ограничений. StrictMode-safe (guard + cleanup).
 */
export function initPromptForge(root: HTMLElement): () => void {
  if (typeof document === 'undefined') return () => {};
  const cleanups: Array<() => void> = [];

  root.querySelectorAll<HTMLElement>('.pforge').forEach((el) => {
    if (el.dataset.pfInit === '1') return;
    el.dataset.pfInit = '1';
    const original = el.innerHTML;

    const previewEl =
      el.querySelector<HTMLElement>('.pf-preview code') ?? el.querySelector<HTMLElement>('.pf-preview');
    const verdict = el.querySelector<HTMLElement>('.pf-verdict');
    const addsEl = el.querySelector<HTMLElement>('.pf-adds');
    const chips = Array.from(el.querySelectorAll<HTMLButtonElement>('.pf-chip'));
    const addChips = chips.filter((c) => c.dataset.add);
    if (!previewEl || addChips.length === 0) return;

    el.classList.add('pf-ready');
    const base = previewEl.textContent ?? '';
    const tpl = new Map<number, string>();
    el.querySelectorAll<HTMLTemplateElement>('template.pf-out').forEach((t) => {
      const lvl = Number(t.dataset.level ?? 0);
      tpl.set(lvl, (t.content?.textContent ?? t.textContent ?? '').replace(/^\n/, '').replace(/\s+$/, ''));
    });

    const need = addChips.length;
    const active = new Set<string>();

    const setVerdict = (text: string, cls: '' | 'pf-err' | 'pf-ok') => {
      if (!verdict) return;
      verdict.textContent = text;
      verdict.className = 'pf-verdict' + (cls ? ' ' + cls : '');
    };

    const render = () => {
      const count = active.size;
      previewEl.textContent = count === 0 ? base : tpl.get(count) ?? base;
      if (addsEl) {
        addsEl.textContent = addChips
          .filter((c) => active.has(c.dataset.add ?? ''))
          .map((c) => (c.textContent ?? '').trim())
          .map((s) => ' · ' + s)
          .join('');
      }
      if (count >= need) {
        setVerdict(el.dataset.fin || 'Чистый LoginPage — годится. Узкий промпт = меньше фантазий AI.', 'pf-ok');
      } else {
        setVerdict('Добавь ограничение — и смотри, как сжимается вывод AI.', '');
      }
    };

    const onChip = (e: Event) => {
      const btn = e.currentTarget as HTMLButtonElement;
      if (btn.dataset.noop !== undefined) {
        btn.classList.toggle('pf-on');
        setVerdict(
          'Это ограничение не сузило задачу — AI выдаст то же. Полезное режет область: страница / методы / локаторы.',
          'pf-err',
        );
        return;
      }
      const id = btn.dataset.add ?? '';
      if (active.has(id)) {
        active.delete(id);
        btn.classList.remove('pf-on');
      } else {
        active.add(id);
        btn.classList.add('pf-on');
      }
      render();
    };

    chips.forEach((c) => c.addEventListener('click', onChip));
    render();

    cleanups.push(() => {
      chips.forEach((c) => c.removeEventListener('click', onChip));
      el.innerHTML = original;
      el.classList.remove('pf-ready');
      delete el.dataset.pfInit;
    });
  });

  return () => cleanups.forEach((fn) => fn());
}
